import React from 'react';
import logoF2 from './../assets/f2.png';
import './index.css';

function Footer() {
  const ano = new Date().getFullYear();
  const certificado = localStorage.getItem('certificado');

  return (
    <footer className="footer-section">
      <div className="footer-container">
        {/* Licença / Empresa */}
        <div className="footer-info">
          <div className="footer-license">Licença: Floresta Comércio e Indústria SA</div>
          <div className="footer-copy">
            © {ano} Todos os direitos reservados.
          </div>
         
        </div>

        {/* Redes Sociais */}
        <div className="footer-social-wrapper">
          <ul className="social-list">
            <li>
              <a href="https://fb.com/florestasm" target="_blank" rel="noreferrer" title="Facebook">
                <i className="bi bi-facebook"></i>
              </a>
            </li>
            <li>
              <a href="https://x.com/florestavr" target="_blank" rel="noreferrer" title="X (Twitter)">
                <i className="bi bi-twitter-x"></i>
              </a>
            </li>
            <li>
              <a href="http://www.instagram.com.br/florestasm" target="_blank" rel="noreferrer" title="Instagram">
                <i className="bi bi-instagram"></i>
              </a>
            </li>
            <li>
              <a href="mailto:suporte@florestasm.com.br" target="_blank" rel="noreferrer" title="E-mail Suporte">
                <i className="bi bi-envelope"></i>
              </a>
            </li>
            <li>
              <a href="https://t.me/florestasm" target="_blank" rel="noreferrer" title="Telegram">
                <i className="bi bi-telegram"></i>
              </a>
            </li>
            <li>
              <a href="https://wa.me/5524988213451" target="_blank" rel="noreferrer" title="WhatsApp">
                <i className="bi bi-whatsapp"></i>
              </a>
            </li>
            <li>
              <a href="https://br.linkedin.com/company/floresta-supermarket" target="_blank" rel="noreferrer" title="LinkedIn">
                <i className="bi bi-linkedin"></i>
              </a>
            </li>
          </ul>
        </div>

        {/* Desenvolvedor */}
        <div className="footer-dev">
          <span>Desenvolvido por</span>
          <img className="dev-logo" alt="F2 Logo" src={logoF2} />
        </div>
         {certificado && (
            <div className="footer-cert">
              🔒 Certificado válido até: <strong>{certificado}</strong>
            </div>
          )}
      </div>
    </footer>
  );
}

export default Footer;